<template lang="pug">
template(v-if="subscription.isNone")
  .headerUserSubscriptionContent
    .text Для полного доступа к сервису,<br> вы можете активировать<br>
      | демо-доступ на #[span {{ daysLeftTextDefault }}]
    ui-button.button(
      size="s"
      color="blue-outline"
      @click="onActivate"
    ) Активировать демо-доступ

template(v-else-if="subscription.isDemo || (subscription.isOver && !store.user.profile.hasSubscriptions)")
  .headerUserSubscriptionContent
    .text
      template(v-if="subscription.isDemo")
        | До окончания демо-доступа {{ leftText }} #[span {{ daysLeftText }}]
      template(v-else)
        | У вас закончился срок демо-доступа.<br>
        | Для работы с сервисом необходимо получить доступ к предметам
    ui-button.button(
      v-if="!isCatalogPage"
      size="s"
      @click="$router.push({ name: 'Catalog'})"
    ) Перейти в витрину

</template>

<script>
import DemoController from '@/controllers/DemoController'
import pluralize from '@/_core/helpers/pluralize'

export default {
  inject: ['store'],
  setup () {
    const demoController = DemoController()

    const onActivate = () => {
      demoController.requestActivate()
    }

    return {
      onActivate
    }
  },
  computed: {
    isCatalogPage () {
      return this.$route.name === 'Catalog'
    },
    subscription () {
      return this.store.user.profile.subscription
    },
    buttonClasses () {
      return this.subscription.isNone ? 'blue-outline' : 'blue'
    },
    daysLeftText () {
      return (
        this.subscription.duration +
        ' ' +
        pluralize(this.subscription.duration, 'день', 'дня', 'дней')
      )
    },
    daysLeftTextDefault () {
      return (
        this.subscription.durationDefault +
        ' ' +
        pluralize(this.subscription.durationDefault, 'день', 'дня', 'дней')
      )
    },
    leftText () {
      return pluralize(this.subscription.duration, 'остался', 'осталось', 'осталось')
    }
  }
}
</script>

<style lang="sass" scoped>
.headerUserSubscriptionContent
  display: flex
  flex-flow: column
  align-items: center
  justify-content: center
  min-width: 81*$u
  box-shadow: $boxShadow

  > .text
    @include font(t14-regular)
    line-height: 1.5
    text-align: center

    &:not(:last-child)
      margin-bottom: 4*$u

    span
      color: $cBlue

  @media (max-width: $padWidth)
    background-color: $cElements
    border-radius: $brM
    padding: 4*$u
    margin-bottom: 5*$u
</style>
